import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTogglerExpended = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2021_1418)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.99995 5.5C8.99995 5.2 9.19995 5 9.49995 5H23.5C23.7999 5 24 5.2 24 5.5C24 5.8 23.7999 6 23.5 6H9.49995C9.19995 6 8.99995 5.8 8.99995 5.5ZM9.49995 12H23.5C23.7999 12 24 11.8 24 11.5C24 11.2 23.7999 11 23.5 11H9.49995C9.19995 11 8.99995 11.2 8.99995 11.5C8.99995 11.8 9.19995 12 9.49995 12ZM5.49995 17C5.59995 17 5.79995 17 5.89995 16.9C6.09995 16.7 6.09995 16.4 5.89995 16.2L1.29995 11.6L5.89995 7C5.99995 6.7 5.99995 6.3 5.89995 6.1C5.79995 5.9 5.29995 6 5.09995 6.1L0.0999512 11.1C-0.100049 11.3 -0.100049 11.6 0.0999512 11.8L5.09995 16.8C5.19995 17 5.39995 17 5.49995 17ZM9.49995 18H23.5C23.7999 18 24 17.8 24 17.5C24 17.2 23.7999 17 23.5 17H9.49995C9.19995 17 8.99995 17.2 8.99995 17.5C8.99995 17.8 9.19995 18 9.49995 18Z",
			fill: "#F5F4F3"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2021_1418",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgTogglerExpended;
